export default "__VITE_ASSET__VaMupgc1__"